import fetch from 'unfetch';
import core from '~/core/scripts';
import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import { DataProvider } from './DataContext.js';
import Navigation from './Navigation.js';
import Map from './Map.js';
import BaseDetails from './BaseDetails.js';

import '../styles/index.styl';

core.init();

// we only want HMR enabled for stylus files
if (module.hot) module.hot.accept(/\.styl$/);

fetch("data/crimedata.json").then( r => r.json()).then(function(crimedata){
  fetch("data/districts.topo.json").then( r => r.json()).then(function(topojson){

  const defaultCrime = ((parseInt(location.hash.slice(1),10)||0)%crimedata.delicts.length);

  ReactDOM.render(
    <DataProvider crimeData={crimedata} defaultCrime={defaultCrime} defaultDistrict="Nordrhein-Westfalen">
      <Fragment>
        <Map data={topojson} />
        <BaseDetails />
        <Navigation />
      </Fragment>
    </DataProvider>,
    document.getElementById('root'));
  });
});

/*
      <Chart />
*/

if (process.env.NODE_ENV === 'development') {
  // enable livereload for index html
  require('file-loader!../index.html');
}
